<script setup lang="ts">
/**
 * CaTrustBar — jawaban langsung untuk temuan audit #7: halaman uang lama punya
 * NOL sinyal kepercayaan. Orang diminta transfer ke situs yang belum pernah
 * mereka dengar; ini yang memberi tahu mereka kenapa itu aman.
 *
 * Butir default DIPERTAHANKAN apa adanya supaya halaman lama di /legacy tidak berubah.
 * Pemanggil boleh mengirim `butir` sendiri — dipakai tema v3, yang hanya
 * memasang klaim yang bisa dipertanggungjawabkan tanpa data tambahan dari
 * pemilik: tidak menyebut angka masa simpan yang belum diverifikasi, dan tidak
 * menjanjikan kanal bantuan selama nomornya belum diisi.
 */
export interface ButirPercaya {
  ikon: string
  judul: string
  detail: string
}

const props = withDefaults(
  defineProps<{ ringkas?: boolean; butir?: ButirPercaya[] }>(),
  { ringkas: false }
)

const butirDefault: ButirPercaya[] = [
  { ikon: 'i-lucide-qr-code', judul: 'Bayar via QRIS', detail: 'Semua e-wallet & m-banking' },
  { ikon: 'i-lucide-shield-check', judul: 'Berkas tidak disimpan', detail: 'Dihapus otomatis 24 jam' },
  { ikon: 'i-lucide-zap', judul: 'Kode langsung keluar', detail: 'Tanpa daftar akun' },
  { ikon: 'i-lucide-message-circle', judul: 'Bantuan WhatsApp', detail: 'Balas di jam kerja' }
]

const daftar = computed(() => props.butir ?? butirDefault)
</script>

<template>
  <ul
    class="grid gap-3 sm:gap-4"
    :class="ringkas ? 'grid-cols-2 lg:grid-cols-4' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'"
  >
    <li
      v-for="b in daftar"
      :key="b.judul"
      class="flex items-start gap-3 rounded-control bg-surface-2 border border-line p-3.5"
    >
      <UIcon :name="b.ikon" class="size-5 shrink-0 text-brand mt-0.5" />
      <div class="min-w-0">
        <p class="text-sm font-semibold leading-snug text-ink">{{ b.judul }}</p>
        <p class="ca-caption text-muted mt-0.5">{{ b.detail }}</p>
      </div>
    </li>
  </ul>
</template>
